import { AsyncStorage, Platform } from "react-native";

import { UUID } from "utils/uuid";

/* 
  * Setting up block level variable to store class state
  * , set's to null by default.
*/
let instance = null;
let login = null;

export class Storage {
	constructor() {
		if (instance) {
			return instance;
		}

		this.getLogin();

		instance = this;
		return instance;
	}

	setLogin() {
		if (Platform.OS === "web") {
			AsyncStorage.setItem("login", true);
			login = true;
		}
	}

	removeLogin() {
		if (Platform.OS === "web") {
			AsyncStorage.setItem("login", false);
			login = false;
		}
	}

	removeRefresh() {
		AsyncStorage.removeItem("refreshValue").catch(err => {
			console.log(err);
		})
	}

	getLogin() {
		try {
			AsyncStorage.getItem("login").then(resp => {
				login = resp;
			});
		} catch (err) {
			console.log(err);
		}
		return login;
	}

	async setIdToken(key, code) {
		try {
			await AsyncStorage.setItem(key, code);
		} catch (error) {
			// Error saving data
			console.log(error);
		}
	}

	signOut() {
		try {
			AsyncStorage.getAllKeys().then(keys => {
				AsyncStorage.multiRemove(keys);
			});
			this.removeRefresh();
		} catch (err) {
			console.log(err);
		}
	}

	async getIdToken(key) {
		try {
			return await AsyncStorage.getItem(key);
		} catch (err) {
			console.log(err);
		}
	}

	async setUUID() {
		const num = UUID.generate();
		try {
			const value = await AsyncStorage.getItem("uuid");
			if (value == null) {
				await AsyncStorage.setItem("uuid", num);
			}
		} catch (err) {
			console.log(err);
			try {
				await AsyncStorage.setItem("uuid", num);
			} catch (error) {
				console.log(error);
			}
		}
	}

	async getDevice() {
		try {
			return await AsyncStorage.getItem();
		} catch (err) {
			console.log(err);
		}
	}

	async setDevice(device) {
		try {
			await AsyncStorage.setItem("coolbreeze:device", device);
		} catch (error) {
			// Error saving data
			console.log(error);
		}
	}

	async setAccessToken(key, token) {
		try {
			await AsyncStorage.setItem(key, token);
		} catch (error) {
			// Error saving data
			console.log(error);
		}
	}

	async getAccessToken(key) {
		try {
			return await AsyncStorage.getItem(key);
		} catch (err) {
			console.log(err);
		}
	}

	async setRefreshToken(key, token) {
		try {
			await AsyncStorage.setItem(key, token);
		} catch (error) {
			// Error saving data
			console.log(error);
		}
	}

	async getRefreshToken(key) {
		try {
			return await AsyncStorage.getItem(key);
		} catch (err) {
			console.log(err);
		}
	}

	async setLastUser(key, token) {
		try {
			await AsyncStorage.setItem(key, token);
		} catch (error) {
			// Error saving data
			console.log(error);
		}
	}

	async setItem(key, code) {
		try {
			await AsyncStorage.setItem(key, code);
		} catch (error) {
			// Error saving data
			console.log(error);
		}
	}

	async getItem(key) {
		try {
			return await AsyncStorage.getItem(key);
		} catch (err) {
			console.log(`failed to get item with ${err}`);
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/storage.js